// extracted by mini-css-extract-plugin
export default {"addToCart":"AddedToCart_addToCart__x2-qw","add":"AddedToCart_add__c184d"};